import { alpha } from "@mui/material/styles";

export const NAVBAR_HEIGHT = { xs: 60, md: 68 };
export const NAVBAR_MAX_WIDTH = 1220;

export const QR_FLEX_WORDMARK_SX = {
    textDecoration: "none",
    fontWeight: 900,
    letterSpacing: "0.03em",
    lineHeight: 1,
    background: "linear-gradient(110deg, #4b4ecf 0%, #7c3aed 44%, #06b6d4 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
};

export const getSharedNavAppBarSx = (scrolled = false) => ({
    backgroundColor: scrolled ? alpha("#f7f8ff", 0.94) : alpha("#f7f8ff", 0.82),
    backdropFilter: "saturate(180%) blur(14px)",
    WebkitBackdropFilter: "saturate(180%) blur(14px)",
    borderBottom: `1px solid ${alpha("#5b5df0", scrolled ? 0.24 : 0.18)}`,
    boxShadow: scrolled ? "0 18px 42px rgba(34, 47, 92, 0.16)" : "0 10px 24px rgba(34, 47, 92, 0.08)",
    transition: "background-color 220ms ease, box-shadow 220ms ease, border-color 220ms ease",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: { xs: 14, md: 18 },
    borderBottomRightRadius: { xs: 14, md: 18 },
    backgroundImage: "none",
});

export const sharedNavToolbarSx = {
    width: "100%",
    maxWidth: NAVBAR_MAX_WIDTH,
    mx: "auto",
    px: { xs: 1.5, md: 2.5 },
    minHeight: NAVBAR_HEIGHT,
    position: "relative",
    display: "flex",
    alignItems: "center",
    gap: 1,
};
